import React from 'react';
import Button from '../Button';
import Modal from '../Modal';
import CurrentUserResource from '../../resources/Auth/CurrentUser';
import { updateUserPropertiesMutation } from '../../resources/Auth/mutations';
import rawCopy from '../../assets/copy';
import { languageOptions } from '../../config/constants';
import useCopy from '../../util/useCopy';

const LanguageModal = ({ isOpen, onClose }) => {
  const [currentUser] = CurrentUserResource.useLoadable();
  const copy = useCopy();

  const handleChange = React.useCallback(
    languageKey => {
      updateUserPropertiesMutation({
        userId: currentUser.id,
        prefersLanguageKey: languageKey,
      });
      onClose();
    },
    [currentUser.id, onClose],
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="LanguageModal">
      <Modal.MainText>
        <p>{copy.selectYourPreferredLanguage}</p>
      </Modal.MainText>
      <Modal.BottomActions>
        {Object.values(languageOptions).map(({ key, getLabel }) => (
          <Button
            key={key}
            stacked
            onClick={() => {
              handleChange(key);
            }}
          >
            {getLabel(rawCopy)}
          </Button>
        ))}
      </Modal.BottomActions>
    </Modal>
  );
};

export default LanguageModal;
